import { API_URL } from "config";
import Http from "util/https";
import prefectures from "util/prefecture";
import { CommonType, CompanySearchOptionsApiResponse, SearchOptionsApiResponse, Shop, StockLargeClassification, StockOptionsResponse, Storehouse, TyreOptions, TyreOptionsApiResponse, VendorResponse, WheelOptions } from "../types";
import { tyreWheelClasses } from "../constants";

type Kind = 'shop' | 'vendor' | 'product';
type Params = {kind: Kind} | {company_cd: string};

/**
 * 仕入先選択肢取得Api
 * @param needStoreOptions 仕入先や倉庫データが必要かどうか
 * @param companyCd 店舗用の場合企業コードから店舗コードを返す
 * @returns レスポンスデータ
 */
export default async function getTyreOptionsApi(needStoreOptions: boolean, companyCd?: string): Promise<StockOptionsResponse> {
  let kind: Kind;
  if (localStorage.getItem('shop_cd')){
    kind = 'shop';
  } else if (localStorage.getItem('supplier_cd')) {
    kind = 'vendor';
  } else {
    kind = 'product';
  }
  const http = Http.default.alterAuth({ useToken: true });
  const url = companyCd ? `${API_URL}/stock/select/company/conditions` : `${API_URL}/stock/select/conditions`;
  const res = await http.get<SearchOptionsApiResponse | CompanySearchOptionsApiResponse>(url);
  console.log(res);

  // const prefs:  {
  //   pref_cd: string;
  //   pref_name: string;
  //   stores: {
  //     store_cd: string;
  //     store_name: string;
  //   }[]
  // }[] = [];
  // // eslint-disable-next-line no-plusplus
  // for (let i = 0; i < 45; i++) {
  //   prefs.push({pref_cd: `${i+1}`.padStart(4, '0'), pref_name: prefectures[i+1].name, stores: Array.from({ length: 2 }, (_,index) => ({store_cd: `${i*2 + index + 1}`.padStart(4,'0'),store_name: `店舗${i*2 + index + 1}`}))});
  // }
  // const vendors = [
  //   { vendor_cd: "000001", vendor_name: "ユピテル株式会社" },
  //   { vendor_cd: "000002", vendor_name: "オートバックス" },
  //   { vendor_cd: "000003", vendor_name: "ﾌﾞﾘﾁﾞｽﾄﾝ" },
  //   { vendor_cd: "000004", vendor_name: "ワーク" },
  // ]
  // const resBase: {data: CommonType<SearchOptionsApiResponse, CompanySearchOptionsApiResponse>} = {data: {
  //   tire_condition: {
  //     tire_width: [135,145,155,165,175,185,195,205],
  //     tire_ratio: [40,45,50,55,60,65,70,75,80],
  //     tire_rim_size: [10,12,13,14,15,16,17,18,19,20]
  //   },
  //   wheel_condition: {
  //     wheel_width: [5,5.5,6,7,8.5,9,10],
  //     wheel_pcd: [100,108,114.3,130],
  //     wheel_hole: [4,5,6],
  //     wheel_rim_size: [10,12,13,14,15,16,17,18,19,20]
  //   },
  //   classes: [
  //     { class_cd: "02", class_name: "タイヤ", vendors: vendors.slice(1,2) },
  //     { class_cd: "03", class_name: "ホイール", vendors: vendors.slice(1,3) },
  //     { class_cd: "04", class_name: "A・V・C", vendors: vendors.slice(0,2) },
  //     { class_cd: "05", class_name: "エンジンオイル", vendors: vendors.slice(1,2) },
  //     { class_cd: "06", class_name: "4輪車バッテリー", vendors: vendors.slice(2,3) },
  //     { class_cd: "07", class_name: "手入れ・洗車・ケミカル", vendors: vendors.slice(3,4) },
  //     { class_cd: "08", class_name: "車内用品", vendors: vendors.slice(2,4) },
  //     { class_cd: "09", class_name: "車外用品", vendors: vendors.slice(0,3) },
  //     { class_cd: "10", class_name: "機能用品", vendors },
  //   ],
  //   brands: [
  //     { brand_cd: "0001", brand_name: "CCI" },
  //     { brand_cd: "0002", brand_name: "ｿﾌﾄ99" },
  //     { brand_cd: "0000", brand_name: "777 ｽﾌﾟﾘｯﾄ" },
  //     { brand_cd: "0000", brand_name: "MID WH STA" },
  //   ],
  // }};

  // let res: {data: SearchOptionsApiResponse | CompanySearchOptionsApiResponse};
  // if (companyCd) {
  //   const companyData: CompanySearchOptionsApiResponse = {...resBase.data, company: {
  //     company_cd: '0001',
  //     company_name: '企業1',
  //     prefs
  //   }}
  //   res = {data: companyData};
  // } else {
  //   const normalData: SearchOptionsApiResponse = {...resBase.data,
  //   depots: [
  //     { depot_cd: "0003", depot_name: "伊藤忠" },
  //     { depot_cd: "0004", depot_name: "昭和製氷" },
  //   ]};
  //   res = {data: normalData};
  // }
  // await new Promise((resolve) => {setTimeout(resolve, 1500)});

  // const prefs:  {
  //   pref_cd: string;
  //   pref_name: string;
  //   stores: {
  //     store_cd: string;
  //     store_name: string;
  //   }[]
  // }[] = [];
  // // eslint-disable-next-line no-plusplus
  // for (let i = 0; i < 45; i++) {
  //   prefs.push({pref_cd: `${i+1}`.padStart(4, '0'), pref_name: prefectures[i+1], stores: Array.from({ length: 2 }, (_,index) => ({store_cd: `${i*2 + index + 1}`.padStart(4,'0'),store_name: `店舗${i*2 + index + 1}`}))});
  // }
  // const vendors = [
  //   { vendor_cd: "000001", vendor_name: "ユピテル株式会社" },
  //   { vendor_cd: "000002", vendor_name: "オートバックス" },
  //   { vendor_cd: "000003", vendor_name: "ﾌﾞﾘﾁﾞｽﾄﾝ" },
  //   { vendor_cd: "000004", vendor_name: "ワーク" },
  // ]
  // const resBase: {data: CommonType<SearchOptionsApiResponse, CompanySearchOptionsApiResponse>} = {data: {
  //   tire_condition: {
  //     tire_width: [135,145,155,165,175,185,195,205],
  //     tire_ratio: [40,45,50,55,60,65,70,75,80],
  //     tire_rim_size: [10,12,13,14,15,16,17,18,19,20]
  //   },
  //   wheel_condition: {
  //     wheel_width: [5,5.5,6,7,8.5,9,10],
  //     wheel_pcd: [100,108,114.3,130],
  //     wheel_hole: [4,5,6],
  //     wheel_rim_size: [10,12,13,14,15,16,17,18,19,20]
  //   },
  //   classes: [
  //     { class_cd: "02", class_name: "タイヤ", vendors: vendors.slice(1,2) },
  //     { class_cd: "03", class_name: "ホイール", vendors: vendors.slice(1,3) },
  //     { class_cd: "04", class_name: "A・V・C", vendors: vendors.slice(0,2) },
  //     { class_cd: "05", class_name: "エンジンオイル", vendors: vendors.slice(1,2) },
  //     { class_cd: "06", class_name: "4輪車バッテリー", vendors: vendors.slice(2,3) },
  //     { class_cd: "07", class_name: "手入れ・洗車・ケミカル", vendors: vendors.slice(3,4) },
  //     { class_cd: "08", class_name: "車内用品", vendors: vendors.slice(2,4) },
  //     { class_cd: "09", class_name: "車外用品", vendors: vendors.slice(0,3) },
  //     { class_cd: "10", class_name: "機能用品", vendors },
  //   ],
  //   brands: [
  //     { brand_cd: "0001", brand_name: "CCI" },
  //     { brand_cd: "0002", brand_name: "ｿﾌﾄ99" },
  //     { brand_cd: "0000", brand_name: "777 ｽﾌﾟﾘｯﾄ" },
  //     { brand_cd: "0000", brand_name: "MID WH STA" },
  //   ],
  // }};

  // let res: {data: SearchOptionsApiResponse | CompanySearchOptionsApiResponse};
  // if (companyCd) {
  //   const companyData: CompanySearchOptionsApiResponse = {...resBase.data, company: {
  //     company_cd: '0001',
  //     company_name: '企業1',
  //     prefs
  //   }}
  //   res = {data: companyData};
  // } else {
  //   const normalData: SearchOptionsApiResponse = {...resBase.data,
  //   depots: [
  //     { depot_cd: "0003", depot_name: "伊藤忠" },
  //     { depot_cd: "0004", depot_name: "昭和製氷" },
  //   ]};
  //   res = {data: normalData};
  // }

  let classificationOptions: StockLargeClassification[] = []
  if (needStoreOptions) {
    classificationOptions = res.data.classes.map(c => ({
      id: c.class_cd,
      name: c.class_name,
      category: tyreWheelClasses.includes(c.class_cd) ? 'tyre_wheel' : 'general',
      suppliers: ('vendors' in c && c.vendors) ? c.vendors.map((v) => ({supplierCd: v.vendor_cd, supplierName: v.vendor_name})) : []
    }));
  } else {
    classificationOptions = res.data.classes.map(c => ({
      id: c.class_cd,
      name: c.class_name,
      category: tyreWheelClasses.includes(c.class_cd) ? 'tyre_wheel' : 'general',
    }));
  }
  const brandOptions: string[] = res.data.brands.map(b => b.brand_name ?? '');
  let shopOptions: Shop[] = [];
  let storehouseOptions: Storehouse[] = [];
  const tyreOptions: TyreOptions = {
    tyreWidthList: [],
    tyreRatioList: [],
    tyreRimDiamList: []
  };
  const wheelOptions: WheelOptions = {
    wheelWidthList: [],
    wheelPcdList: [],
    wheelHoleList: [],
    wheelRimDiamList: []
  };
  if (kind !== 'vendor') {
    // 仕入先・外部倉庫以外はタイヤ・ホイールのサイズをそれぞれ入れる
    tyreOptions.tyreWidthList = res.data.tire_condition.tire_width;
    tyreOptions.tyreRatioList = res.data.tire_condition.tire_ratio;
    tyreOptions.tyreRimDiamList = res.data.tire_condition.tire_rim_size;
    wheelOptions.wheelWidthList = res.data.wheel_condition.wheel_width;
    wheelOptions.wheelPcdList = res.data.wheel_condition.wheel_pcd;
    wheelOptions.wheelHoleList = res.data.wheel_condition.wheel_hole;
    wheelOptions.wheelRimDiamList = res.data.wheel_condition.wheel_rim_size;
  }
  if (companyCd && 'company' in res.data) {
    shopOptions = res.data.company.prefs.map(pref => pref.stores.map(s => ({clientCd: s.client_cd, shopCd: s.store_cd, shopName: s.store_name, prefecture: Number(pref.pref_cd)}))).flat();
  } else if ('depots' in res.data && res.data.depots.length > 0) {
    storehouseOptions = res.data.depots.map(w => ({id: w.depot_cd, name: w.depot_name, region: ''}));
  }
  await new Promise<void>((resolve) => {setTimeout(resolve, 1500)});

  console.log({
    tyreOptions,
    wheelOptions,
    classificationOptions,
    brandOptions,
    storehouseOptions,
    shopOptions,
  })
  return {
    tyreOptions,
    wheelOptions,
    classificationOptions,
    brandOptions,
    storehouseOptions,
    shopOptions,
  };
}
